// "Raise a SAFed test" as a modal (Session BDC): the lift page, site page, customer page and Compliance SAFed section open this with
// whatever they already know (the lift, or the customer or site that narrows the lift list). It is the same form the lift page's panel
// uses, so a SAFed job raised from anywhere follows exactly the same rules.
import { ModalShell } from "../../components/ModalShell";
import { SafedRaisePicker } from "./register/safed/SafedRaisePicker";

export function RaiseSafedTestModal({
  assetId,
  customerId,
  siteId,
  onClose,
  onRaised,
}: {
  assetId?: string | null;
  customerId?: string | null;
  siteId?: string | null;
  onClose: () => void;
  onRaised: (jobId: string | null) => void;
}) {
  return (
    <ModalShell ariaLabel="Raise a SAFed test" onClose={onClose} width="max-w-[560px]" panelClassName="p-6 max-h-[85vh] overflow-y-auto">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div>
          <h2 className="font-heading text-xl text-ele-strong">Raise a SAFed test</h2>
          <p className="text-sm text-ele-body">Supplementary testing is its own job type. Nothing is sent and no invoice is raised.</p>
        </div>
        <button onClick={onClose} aria-label="Close" className="-mr-2 -mt-2 flex min-h-11 min-w-11 items-center justify-center rounded-ele text-ele-body hover:text-ele-green">
          ✕
        </button>
      </div>
      <SafedRaisePicker assetId={assetId} customerId={customerId} siteId={siteId} onRaised={onRaised} onCancel={onClose} />
    </ModalShell>
  );
}
